import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UILink from 'UIComponents/link/UILink';
import { devices } from '../styles/viewports.styles';
const StyledManageCookiesContainer = styled.div.withConfig({
  displayName: "ManageCookies__StyledManageCookiesContainer",
  componentId: "sc-109r8ik-0"
})(["font-size:17px !important;text-align:center;display:flex;justify-content:center;align-items:end;margin-top:40px;@media ", "{z-index:2147483647 !important;margin-top:0;display:block;text-align:end;position:fixed;bottom:0;padding-bottom:30px;right:100px;}"], devices.desktop);
const StyledManageCookiesLink = styled(UILink).withConfig({
  displayName: "ManageCookies__StyledManageCookiesLink",
  componentId: "sc-109r8ik-1"
})(["color:#0b8484 !important;"]);
export const ManageCookies = () => {
  return /*#__PURE__*/_jsx(StyledManageCookiesContainer, {
    children: /*#__PURE__*/_jsx("div", {
      className: "hs-footer-cookie-settings",
      hidden: true,
      children: /*#__PURE__*/_jsx(StyledManageCookiesLink, {
        href: "#"
      })
    })
  });
};